'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { useRouter } from '@sola/ark-core/utils/hooks/useRouter.ts';
import { useSponsorships } from '@sola/supporter-sdk/hooks/commitments.ts';
import { SponsorshipCard } from '../../molecules/sponsorship-card/sponsorship-card.tsx';
import { SponsorshipsSkeleton } from './sponsorships-skeleton.tsx';
export const useComponentData = () => {
  const $ = _c(6);
  const {
    sponsorships,
    isLoading,
    isFetching,
    isPending,
    isError
  } = useSponsorships();
  const isShowingSkeletons = (isLoading || isFetching || isPending) && !isError;
  const isShowingSponsorships = !isShowingSkeletons && !!sponsorships?.length;
  const hasNoSponsorships = !isShowingSkeletons && !isError && sponsorships.length === 0;
  let t0;
  if ($[0] !== hasNoSponsorships || $[1] !== isError || $[2] !== isShowingSkeletons || $[3] !== isShowingSponsorships || $[4] !== sponsorships) {
    t0 = {
      isShowingSkeletons,
      hasError: isError,
      sponsorships,
      isShowingSponsorships,
      hasNoSponsorships
    };
    $[0] = hasNoSponsorships;
    $[1] = isError;
    $[2] = isShowingSkeletons;
    $[3] = isShowingSponsorships;
    $[4] = sponsorships;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};

/**
 * Displays sponsorships sorted alphabetically by child name
 */
export const SponsorshipsList = () => {
  const {
    hasNoSponsorships,
    isShowingSkeletons,
    isShowingSponsorships,
    sponsorships,
    hasError
  } = useComponentData();
  const {
    t
  } = useTranslation(['my', 'core']);
  const {
    usePathname
  } = useRouter();
  // eslint-disable-next-line react-compiler/react-compiler -- usePathname is a framework-agnostic hook passed via RouterContext
  const pathname = usePathname();
  const basePath = pathname.replace(/\/$/, '');
  return <div className="SponsorshipsList max-w-md flex flex-col gap-comfy-xl">
      {/* Loading state with skeletons */}
      {isShowingSkeletons && <SponsorshipsSkeleton />}

      {/* Success state - display sponsorships */}
      {isShowingSponsorships && <div className="SponsorshipsList__group flex flex-col gap-comfy-xs max-w-container-lg">
          {sponsorships.map(sponsorship => <SponsorshipCard key={sponsorship.internalId} commitment={sponsorship}
      /**
       * TODO: First, we probably want a system for getting/passing the contenPosition for mySponsorships here.
       * Second, the component itself might want to handle this, or at least have a fallback.
       */ href={`${basePath}/${sponsorship.participant?.globalId}`} />)}
        </div>}

      {/* TODO: We have designs to implement */}
      {hasNoSponsorships && <>
          <h3 className="heading-sm mb-snug-xl">
            {t('sponsorships.noSponsorships.title')}
          </h3>

          <p className="body-sm label-neutral-mild">
            {t('sponsorships.noSponsorships.message')}
          </p>
        </>}

      {/* Error state */}
      {hasError && <Alert variant="negative" title={t('sponsorships.queryError.title')} message={t('sponsorships.queryError.message')} action={<a href={t('my:ctas.contactSupport.url')}>
              {t('my:ctas.contactSupport.text')}
            </a>} />}
    </div>;
};